import React, { useContext, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { get } from "lodash";
import { ManageRkaasMenu, LoaderWrapper } from "../../../components";
import { withAppLayout } from "../../../hoc";
import { MANAGE_RKAAS_MENU } from "../../../utils";
import { ManageRkaasRoutes } from "../../../routes";
import {
  ManageRkaasProvider,
  manageRkaasStore,
  setManageRkaasSelectedMenu,
} from "../../../contexts";

export const ManageRkaas = (props) => {
  const { location } = props;
  const { state, dispatch } = useContext(manageRkaasStore);
  const { isFetching } = get(state, "api", {});
  const flow = get(state, "flow");

  useEffect(() => {
    dispatch(setManageRkaasSelectedMenu(location.pathname));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const isLoading = get(state, "isLoading");

  return (
    <LoaderWrapper
      isLoading={isLoading || isFetching}
      className="row manage-company-wrapper"
    >
      <Col className="h-100">
        <Row sm="12" className="h-100">
          <Col className="manage-company-column manage-menu-items">
            <div className="company-name-component">{""}</div>
            <ManageRkaasMenu
              menuList={MANAGE_RKAAS_MENU}
              selectedMenu={get(state, "selectedMenu")}
              flow={flow}
            />
          </Col>
          <Col className="h-100 manage-menu-content">
            <ManageRkaasRoutes />
          </Col>
        </Row>
      </Col>
    </LoaderWrapper>
  );
};

const ManageRkaasWithProvider = (props) => {
  return (
    <ManageRkaasProvider>
      <ManageRkaas {...props} />
    </ManageRkaasProvider>
  );
};

export default withAppLayout(ManageRkaasWithProvider);
